import React, { FC } from 'react';
import * as Styled from './styles';

interface Props {
    size?: 'small' | 'large';
}
/** Animated spinner with background. TODO: replace with SB Design System */
const Spinner: FC<Props> = ({ size = 'large' }) => (
    <Styled.SpinnerSVG
        width="192"
        height="192"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        size={size}
    >
        <mask
            id="mask0_409_26136"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
        >
            <path
                d="M20.4704 3.52941C25.1485 8.20759 25.1485 15.7924 20.4704 20.4706C15.7922 25.1488 8.20736 25.1488 3.52918 20.4706C-1.149 15.7924 -1.149 8.20759 3.52918 3.52941C8.20736 -1.14876 15.7922 -1.14876 20.4704 3.52941ZM5.90094 18.0988C9.26923 21.4671 14.7303 21.4671 18.0986 18.0988C21.4669 14.7305 21.4669 9.26946 18.0986 5.90118C14.7303 2.53289 9.26923 2.53289 5.90094 5.90118C2.53266 9.26946 2.53266 14.7305 5.90094 18.0988Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_409_26136)">
            <path
                d="M23.9789 12C23.9789 18.6159 18.6157 23.9792 11.9997 23.9792C5.38379 23.9792 0.0205078 18.6159 0.0205078 12C0.0205078 5.38403 5.38379 0.020752 11.9997 0.020752C18.6157 0.020752 23.9789 5.38403 23.9789 12ZM3.37469 12C3.37469 16.7634 7.23625 20.625 11.9997 20.625C16.7632 20.625 20.6248 16.7634 20.6248 12C20.6248 7.23649 16.7632 3.37493 11.9997 3.37493C7.23625 3.37493 3.37469 7.23649 3.37469 12Z"
                fill="#E2E2E4"
            />
            <Styled.SpinnerG>
                <path
                    d="M20.7364 17.4593C21.5219 17.9501 21.7691 18.9942 21.1734 19.7035C20.2426 20.812 19.1155 21.7462 17.8439 22.4569C16.0825 23.4413 14.1011 23.9648 12.0834 23.9789C10.0656 23.993 8.07705 23.4972 6.30212 22.5375C5.02073 21.8446 3.88067 20.9262 2.93445 19.8308C2.32897 19.1299 2.56154 18.0825 3.3401 17.5807C4.11866 17.079 5.14649 17.3181 5.78922 17.985C6.40303 18.622 7.1135 19.1631 7.89745 19.587C9.1754 20.278 10.6072 20.6349 12.0599 20.6248C13.5127 20.6147 14.9394 20.2377 16.2075 19.529C16.9855 19.0942 17.6883 18.5432 18.2932 17.8977C18.9265 17.2219 19.9509 16.9684 20.7364 17.4593Z"
                    fill="#006CFF"
                />
            </Styled.SpinnerG>
        </g>
    </Styled.SpinnerSVG>
);

export default Spinner;
